export const iconFontAwesomeGamingDAndDBeyond = (
	<i className="fa-solid fa-d-and-d-beyond"></i>
);
